<template>
    <div :id="editorId" style="width: 100%; height: 100%;"></div>
</template>

<script>
import ace from 'ace-builds/src-noconflict/ace';
require('ace-builds/webpack-resolver')
require('ace-builds/src-noconflict/mode-javascript')
require('ace-builds/src-noconflict/mode-xml')

export default {
  name: 'AceEditor',
  props: ['editorId', 'content', 'lang', 'theme'],
  data () {
    return {
      editor: Object,
      beforeContent: '',
      currentContent: '',
    }
  },
  watch: {
    'content' (value) {
      if (this.beforeContent !== value) {
        this.editor.setValue(value, 1)
      }
    }
  },
  methods: {
    getContent() {
      return this.editor.getValue();
    },
    setContent(val) {
      this.editor.setValue(val,1);
    },
    insert(val) {
      this.editor.session.insert(this.editor.getCursorPosition(), val)
    }
  },
  mounted () {
    const lang  = this.lang || 'text'
    const theme = this.theme || 'textmate'

    //ace.config.set('basePath', '/ace/theme/')
    this.editor = ace.edit(this.editorId)

    if (this.content) {
      this.editor.setValue(this.content, 1)
    } else {
      this.editor.setValue('',1);
    }

    if (lang !== 'text') {
      console.log('try set lang: ' + lang);
      this.editor.getSession().setMode(`ace/mode/${lang}`)
    }
    this.editor.setTheme(`ace/theme/${theme}`)

    //this.editor.on('change', () => {
    //  this.beforeContent = this.editor.getValue()
      //this.$emit('change-content', this.editor.getValue())
    //  this.content = this.editor.getValue();
    //})
  },
  beforeDestroy: function() {
    console.log('destroy');
    if (this.editor.destroy) {
      console.log('rem editor');
      this.editor.destroy();
    }
  }
}
</script>
